import React, { useState } from 'react';
import { Plus, MapPin, Clock, Users, Calendar } from 'lucide-react';

const EventsList = ({ events }) => {
  const [filter, setFilter] = useState('all');

  const filteredEvents = events.filter(event => {
    if (filter === 'today') return event.time.includes('Today');
    if (filter === 'professional') return event.type === 'professional';
    if (filter === 'casual') return event.type === 'casual';
    return true;
  });

  return (
    <div className="screen">
      <div className="screen-header">
        <h1 className="screen-title">Events</h1>
        <p className="screen-subtitle">Connect through local meetups</p>
      </div>

      {/* Filter Bar */}
      <div style={{ 
        padding: '0 20px 16px',
        display: 'flex',
        gap: '8px',
        overflowX: 'auto'
      }}>
        {['all', 'today', 'professional', 'casual'].map((filterType) => (
          <button
            key={filterType}
            onClick={() => setFilter(filterType)}
            style={{
              background: filter === filterType 
                ? 'linear-gradient(135deg, #667eea, #764ba2)' 
                : 'rgba(255, 255, 255, 0.8)',
              color: filter === filterType ? 'white' : '#666',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              borderRadius: '20px',
              padding: '8px 16px',
              fontSize: '13px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              backdropFilter: 'blur(20px)',
              whiteSpace: 'nowrap'
            }}
          >
            {filterType.charAt(0).toUpperCase() + filterType.slice(1)}
          </button>
        ))}
      </div>

      {/* Events List */}
      <div style={{ paddingBottom: '20px' }}>
        {filteredEvents.map((event) => (
          <div key={event.id} className="event-card">
            <div style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '12px',
              marginBottom: '16px'
            }}>
              <div style={{
                width: '48px',
                height: '48px',
                background: event.type === 'professional' 
                  ? 'linear-gradient(135deg, #667eea, #764ba2)'
                  : 'linear-gradient(135deg, #f093fb, #f5576c)',
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white'
              }}>
                <Calendar size={20} />
              </div>
              <div style={{ flex: 1 }}>
                <div className="event-title">{event.title}</div>
                <div style={{ fontSize: '13px', color: '#666', marginBottom: '4px' }}>
                  by {event.organizer}
                </div>
                <div className="event-meta">
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <Clock size={14} />
                    {event.time}
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <MapPin size={14} />
                    {event.location}
                  </div>
                </div>
              </div>
              <div style={{
                background: event.type === 'professional' 
                  ? 'rgba(102, 126, 234, 0.1)'
                  : 'rgba(240, 147, 251, 0.1)',
                color: event.type === 'professional' ? '#667eea' : '#f5576c',
                padding: '4px 8px',
                borderRadius: '6px',
                fontSize: '11px',
                fontWeight: '600',
                textTransform: 'capitalize'
              }}>
                {event.type}
              </div>
            </div>
            
            <div className="event-description">{event.description}</div>
            
            <div className="event-footer">
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <Users size={14} style={{ color: '#667eea' }} />
                <span className="attendees-count">{event.attendees} attending</span>
              </div>
              <button className="join-btn">Join Event</button>
            </div>
          </div>
        ))}
      </div>

      {/* Create Event Button */}
      <button className="add-btn">
        <Plus size={20} />
      </button>
    </div>
  );
};

export default EventsList;